module.exports = __webpack_public_path__ + "static/media/Yoyo_6443.d70f3696.jpg";